"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MessageBroadcastIn = void 0;
class MessageBroadcastIn {
    constructor() {
    }
    static getAttributeTypeMap() {
        return MessageBroadcastIn.attributeTypeMap;
    }
}
exports.MessageBroadcastIn = MessageBroadcastIn;
MessageBroadcastIn.discriminator = undefined;
MessageBroadcastIn.attributeTypeMap = [
    {
        "name": "channels",
        "baseName": "channels",
        "type": "Array<string>",
        "format": ""
    },
    {
        "name": "eventId",
        "baseName": "eventId",
        "type": "string",
        "format": ""
    },
    {
        "name": "eventType",
        "baseName": "eventType",
        "type": "string",
        "format": ""
    },
    {
        "name": "payload",
        "baseName": "payload",
        "type": "any",
        "format": ""
    },
    {
        "name": "payloadRetentionPeriod",
        "baseName": "payloadRetentionPeriod",
        "type": "number",
        "format": "int64"
    }
];
//# sourceMappingURL=MessageBroadcastIn.js.map